
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  featuresFlagList: [],
};

const featuresFlagSlice = createSlice({
  name: 'featuresFlag',
  initialState,
  reducers: {
    aGetFeaturesFlagSuccess: (state, action) => {
      state.featuresFlagList = action.payload?.featuresFlag;
    },
  },
});

export const { aGetFeaturesFlagSuccess } = featuresFlagSlice.actions;

export default featuresFlagSlice.reducer;
